import { render, staticRenderFns } from "./MyQuotations.vue?vue&type=template&id=03974398&"
import script from "./MyQuotations.vue?vue&type=script&lang=js&"
export * from "./MyQuotations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports